import {
  getAvatarImagePath,
  getSmallHeroImagePath,
  getAboutImageUrl,
  getGridCellImageUrl
} from "../helpers/imageUrlHelper";

export const entityTypes = {
  CAMPAIGN: "campaign",
  FUNDRAISER: "fundraiser",
  TEAM: "team",
  PAGE: "page",
  ORGANIZATION: "organization",
  ACCOUNT: "account",
  EVENT: "event"
} as const;
export type Entity = (typeof entityTypes)[keyof typeof entityTypes];

export const uploadTypes = {
  LOGO: "logo",
  HERO_IMAGE: "heroImage",
  AVATAR: "avatar",
  ASSET: "asset",
  THANK_YOU: "thankYou",
  CELL: "cell",
  BULK_DATA: "bulkData",
  PDF: "pdf"
} as const;
export type UploadType = (typeof uploadTypes)[keyof typeof uploadTypes];

export const imageAspectRatio = {
  [uploadTypes.AVATAR]: 1,
  [uploadTypes.LOGO]: 1,
  [uploadTypes.HERO_IMAGE]: 4.29
} as const;

export const resizerMethods = {
  [uploadTypes.AVATAR]: getAvatarImagePath,
  [uploadTypes.LOGO]: getAvatarImagePath,
  [uploadTypes.HERO_IMAGE]: getSmallHeroImagePath,
  [uploadTypes.ASSET]: getAboutImageUrl,
  [uploadTypes.THANK_YOU]: getAboutImageUrl,
  [uploadTypes.CELL]: getGridCellImageUrl,
  [uploadTypes.BULK_DATA]: () => console.error("Unimplemented resizer method!"),
  [uploadTypes.PDF]: () => console.error("Unimplemented resizer method!"),
};

export const getFullImagePathByType = (imagePath: string, uploadType: UploadType) => {
  const resizerMethod = resizerMethods[uploadType];
  if (resizerMethod && imagePath) {
    return resizerMethod(imagePath);
  }
  return "";
};

export const imageFormats = ["JPEG", "PNG", "JPG"] as const;
export type ImageFormat = (typeof imageFormats)[number];

export const iconFormats = ["SVG+XML"];
